import Input from 'components/shared/Input/Input';

const ContactFields = ({ formik }) => {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-1 md:grid-cols-2">
      <Input
        data-qa="practice-email"
        label="Email address"
        placeholder="Enter email address"
        name="practiceEmail"
        value={formik.values.practiceEmail}
        onChange={formik.handleChange}
        error={formik.touched.practiceEmail && formik.errors.practiceEmail}
      />
      <Input
        data-qa="practice-phone-number"
        label="Phone number"
        placeholder="Enter phone number"
        name="practicePhone"
        isOptional
        value={formik.values.practicePhone}
        onChange={formik.handleChange}
        error={formik.touched.practicePhone && formik.errors.practicePhone}
      />
    </div>
  );
};

export default ContactFields;
